import React from 'react';
import { Link } from '@tanstack/react-router';

// Preview card for a blog post from the blog registry (src/blog).
const BlogPreview = ({ post, compact = false }) => {
  return (
    <Link
      to="/blog/$slug"
      params={{ slug: post.slug }}
      className="group flex flex-col overflow-hidden rounded-xl border border-border/60 bg-background-elevated shadow-sm hover:shadow-md hover:border-border transition-all duration-200"
    >
      <img
        className="w-full h-auto aspect-[1200/630] object-cover"
        src={post.image}
        alt=""
        width="1200"
        height="630"
        loading="lazy"
      />
      <div className={`flex flex-1 flex-col ${compact ? 'p-4' : 'p-6'}`}>
        <p className="text-xs font-semibold text-accent uppercase tracking-wide">{post.category}</p>
        <h3 className={`mt-2 font-semibold text-foreground group-hover:text-accent transition-colors ${compact ? 'text-base' : 'text-xl'}`}>
          {post.title}
        </h3>
        {!compact && <p className="mt-3 text-muted-foreground flex-1">{post.description}</p>}
        <p className="mt-4 text-sm text-muted-foreground">{post.readingMinutes} min read</p>
      </div>
    </Link>
  );
};

export default BlogPreview;
